import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

export default function PageShell({ children, testId }) {
  const { pathname } = useLocation();

  // Scroll to top when navigating to a new page.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <SmoothScroll>
      <div className="grain-overlay" />
      <Nav />
      <main data-testid={testId} className="pt-20">
        {children}
      </main>
      <Footer />
    </SmoothScroll>
  );
}
